// ============================================================
// หน้า SaleListingLogs — ประวัติการขาย (log ของ flow ขาย/เช่า)
// ------------------------------------------------------------
// ตอบคำถามว่า ประกาศใบหนึ่ง "เปลี่ยนสถานะวันไหน เวลาไหน โดยใคร
// มีนัดเข้ามากี่คน อะไรบ้าง เวลาไหนบ้าง"
//
// ข้อมูลมาจาก GET api/admin/sale-listing-logs (append-only ฝั่ง backend)
// หน้านี้จึงอ่านอย่างเดียว ไม่มีปุ่มแก้/ลบ
//
// ★ เปิดจากหน้าอื่นแบบเจาะห้องเดียวได้ด้วย /sale-listing-logs?listing_uid=<uid>
// ============================================================

import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";

import PropertyNavbar from "../../components/PropertyNavbar.js";
import { loading, GET, getCurrentProject, formatSaleDateTime, DatePicker } from "../../components/CustomComponent.js";
import { stripJuristic } from "../../components/text-sanitize.js";

import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";

// หมวดของประวัติ — ตรงกับ CATEGORY ฝั่ง backend
const CATEGORY_LIST = ["ประกาศ", "นัดดูห้อง"];

// สีป้ายตามการกระทำ อ่านตารางยาว ๆ แล้วกวาดตาหาเรื่องที่สนใจได้เร็ว
const actionClass = (action) => {
    if (["สร้างประกาศ", "เผยแพร่ประกาศ"].includes(action)) return "bg-success-light text-success";
    if (["ยกเลิกประกาศ", "หยุดเผยแพร่ประกาศ"].includes(action)) return "bg-danger-light text-danger";
    if (action === "นัดดูห้องใหม่") return "bg-primary-light text-primary";
    if (["เปลี่ยนสถานะขาย", "เปลี่ยนสถานะเช่า", "เปลี่ยนสถานะนัด"].includes(action)) return "bg-warning-light text-warning";
    return "bg-secondary-light text-secondary";
};

export default class SaleListingLogs extends Component {
    constructor(props) {
        super(props);

        const query = new URLSearchParams(window.location.search);
        this.state = {
            data: [],
            count: 0,
            page: 1,
            page_size: 20,

            // ★ มาจาก query string = ล็อกไว้ที่ห้องเดียว ไม่ให้ล้างตัวกรองแล้วหลุดไปทั้งโครงการ
            listing_uid: query.get("listing_uid") || "",

            filter_category: "",
            filter_search: "",
            filter_date_start: "",
            filter_date_end: "",
        };
    }

    componentDidMount() {
        if (!localStorage.getItem("cds-acc-tk")) {
            localStorage.clear();
            window.location.href = "/";
            return;
        }
        loading(false);
        this.getData();
    }

    getData = async () => {
        loading(true);
        const result = await GET("api/admin/sale-listing-logs", {
            page: this.state.page,
            page_size: this.state.page_size,
            listing_uid: this.state.listing_uid,
            category: this.state.filter_category,
            data_search: this.state.filter_search,
            date_start: this.state.filter_date_start,
            date_end: this.state.filter_date_end,
        });
        if (result?.status) {
            this.setState({ data: result.data || [], count: result.count || 0 });
        }
        loading(false);
    };

    search = () => {
        this.setState({ page: 1 }, this.getData);
    };

    clear = () => {
        this.setState({
            page: 1,
            filter_category: "",
            filter_search: "",
            filter_date_start: "",
            filter_date_end: "",
        }, this.getData);
    };

    render() {
        const s = this.state;
        const project = getCurrentProject();

        return (
            <div className="w-100 h-100">
                <PropertyNavbar menuKey="sales-listing-logs" page1="จัดการทรัพย์" page2="ประวัติการขาย" />

                <div className="body p-3">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4">
                        <div className="p-4">
                            <small className="text-secondary">โครงการที่เลือก</small>
                            <h3 className="fw-bold mb-1">{stripJuristic(project?.project_name) || "-"}</h3>
                            <div className="text-secondary">
                                ประวัติการประกาศขาย/ให้เช่า และการนัดดูห้อง — บันทึกอัตโนมัติ แก้ไขไม่ได้
                            </div>
                            {!!s.listing_uid && (
                                <div className="mt-2">
                                    <span className="badge bg-primary-light text-primary">
                                        แสดงเฉพาะประกาศที่เลือกไว้
                                    </span>
                                    <button
                                        className="btn btn-link btn-sm"
                                        onClick={() => this.setState({ listing_uid: "", page: 1 }, this.getData)}
                                    >
                                        ดูทั้งโครงการ
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card border-0 p-3">
                        <div className="d-flex flex-wrap align-items-center mb-3">
                            <h5 className="mb-0 me-auto">
                                <b>ประวัติการขาย</b>
                            </h5>
                        </div>

                        <div className="d-flex flex-wrap mb-3">
                            <input
                                type="text"
                                className="form-control wpx-220 me-2 mb-2"
                                placeholder="ค้นหา เลขห้อง / ผู้ทำรายการ / รายละเอียด"
                                value={s.filter_search}
                                onChange={(e) => this.setState({ filter_search: e.target.value })}
                                onKeyDown={(e) => { if (e.key === "Enter") this.search(); }}
                            />
                            <select
                                className="form-control wpx-160 rounded me-2 mb-2"
                                value={s.filter_category}
                                onChange={(e) => this.setState({ filter_category: e.target.value })}
                            >
                                <option value="">ทุกหมวด</option>
                                {CATEGORY_LIST.map((item) => (
                                    <option value={item} key={item}>{item}</option>
                                ))}
                            </select>
                            {/* ★ ช่องวันที่ใช้ DatePicker เสมอ (dd/mm/yyyy) ไม่ใช้ input type="date" ที่แสดงตาม locale เบราว์เซอร์ */}
                            <div className="wpx-160 me-2 mb-2">
                                <DatePicker
                                    className="form-control"
                                    value={s.filter_date_start}
                                    onChange={(value) => this.setState({ filter_date_start: value })}
                                />
                            </div>
                            <div className="wpx-160 me-2 mb-2">
                                <DatePicker
                                    className="form-control"
                                    value={s.filter_date_end}
                                    onChange={(value) => this.setState({ filter_date_end: value })}
                                />
                            </div>
                            <button className="btn btn-success px-4 me-2 mb-2" onClick={this.search}>ค้นหา</button>
                            <button className="btn btn-outline-success px-4 me-2 mb-2" onClick={this.clear}>ล้างค่า</button>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="bg-light text-secondary">
                                    <tr>
                                        <th className="wpx-160">วันที่ / เวลา</th>
                                        <th className="wpx-100">ห้อง</th>
                                        <th className="wpx-100">หมวด</th>
                                        <th className="wpx-160">การกระทำ</th>
                                        <th>การเปลี่ยนแปลง</th>
                                        <th>รายละเอียด</th>
                                        <th className="wpx-180">ผู้ทำรายการ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {s.data.length === 0 && (
                                        <tr>
                                            <td colSpan={7} className="text-center text-secondary py-4">ไม่พบประวัติ</td>
                                        </tr>
                                    )}
                                    {s.data.map((item, index) => (
                                        <tr key={item.uid || index}>
                                            <td>{formatSaleDateTime(item.created_at) || "-"}</td>
                                            <td>{item.address_number || "-"}</td>
                                            <td>{item.category || "-"}</td>
                                            <td className="py-2">
                                                <span className={"badge " + actionClass(item.action)}>{item.action || "-"}</span>
                                            </td>
                                            <td>
                                                {/* ค่าก่อน/หลัง มีเฉพาะรายการที่เป็นการเปลี่ยนค่า */}
                                                {item.old_value || item.new_value ? (
                                                    <span>
                                                        <span className="text-secondary">{item.old_value || "-"}</span>
                                                        <span className="mx-2">{"\u2192"}</span>
                                                        <b>{item.new_value || "-"}</b>
                                                    </span>
                                                ) : "-"}
                                            </td>
                                            <td>{item.detail || "-"}</td>
                                            <td>
                                                {item.actor_name || "-"}
                                                {!!item.actor_type && (
                                                    <small className="text-secondary d-block">{item.actor_type}</small>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="w-100 d-flex align-items-center justify-content-between pt-3">
                            <small>ทั้งหมด {s.count} รายการ</small>
                            <Pagination
                                page={s.page}
                                count={Math.ceil(s.count / s.page_size) || 1}
                                showFirstButton
                                showLastButton
                                onChange={(_, page) => this.setState({ page }, this.getData)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
